<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">
            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" width="200px">
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span  class="text-link">{{scope.row.policy_number}}</span>
            </template>          
            </el-table-column>                

            <!-- 船舶名 -->
            <el-table-column align="left" label="船舶名">
            <template slot-scope="scope">
                <!-- <span class="text-link" @click="handleUpdate(scope.row.id)">{{ scope.row.ship_name }}</span> -->
                <span class="text-link" >{{ scope.row.ship_name }}</span>
            </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.insruance_type }}</span>
            </template>
            </el-table-column>        

            <!-- 客户 -->
            <el-table-column align="left" label="客户" >
            <template slot-scope="scope">
                <span>{{ scope.row.client }}</span>
            </template>
            </el-table-column>

            <!-- 含税保费 -->
            <el-table-column align="left" label="含税保费" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.premium}}</span>
            </template>
            </el-table-column>

            <!-- 不含税保费 -->
            <el-table-column align="left" label="不含税保费" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_premium}}</span>
            </template>
            </el-table-column>                

            <!-- 出单时间 -->
            <el-table-column align="left" label="出单时间" width="150px">
            <template slot-scope="scope">
                <span>{{ scope.row.paid_time | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 比例 -->
            <el-table-column align="left" label="比例" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate }}%</span>
            </template>
            </el-table-column>

            <!-- 含税手续费 -->
            <el-table-column align="left" label="含税手续费" width="100px">
            <template slot-scope="scope">
                <span>{{ scope.row.commission }}</span>
            </template>
            </el-table-column>

            <!-- 不含税手续费 -->
            <el-table-column align="left" label="不含税手续费" width="120px">
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_commission }}</span>
            </template>
            </el-table-column>                
        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-ping-an',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },        
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>